import { render, staticRenderFns } from "./CategoriesAndItems.vue?vue&type=template&id=6690949a&"
import script from "./CategoriesAndItems.vue?vue&type=script&lang=js&"
export * from "./CategoriesAndItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports